var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7559 0.410765C20.0814 0.736202 20.0814 1.26384 19.7559 1.58928L11.8393 9.50594C11.5138 9.83138 10.9862 9.83138 10.6607 9.50594L7.08333 5.92853L1.42259 11.5893C1.09715 11.9147 0.569515 11.9147 0.244078 11.5893C-0.0813592 11.2638 -0.0813592 10.7362 0.244078 10.4108L6.49408 4.16077C6.81951 3.83533 7.34715 3.83533 7.67259 4.16077L11.25 7.73818L18.5774 0.410765C18.9028 0.0853278 19.4305 0.0853278 19.7559 0.410765Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 1.00002C13.3333 0.539783 13.7064 0.166687 14.1667 0.166687H19.1667C19.6269 0.166687 20 0.539783 20 1.00002V6.00002C20 6.46026 19.6269 6.83335 19.1667 6.83335C18.7064 6.83335 18.3333 6.46026 18.3333 6.00002V1.83335H14.1667C13.7064 1.83335 13.3333 1.46026 13.3333 1.00002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/Trade.a736f68b48b8ae5ae487b7c42cbe837b.svg";
export { ForwardRef as ReactComponent };